import { PropertyCategoryId, definePropertyCategoryId } from "./PropertyCategoryId";

export interface PropertyCategory {
    id: PropertyCategoryId;
    name: string; // i18n key, resolved via useTranslation() at render time
    parentId?: PropertyCategoryId;
    sortOrder: number;
}

const registry = new Map<PropertyCategoryId, PropertyCategory>();

function registerCategory(category: PropertyCategory): PropertyCategory {
    registry.set(category.id, category);
    return category;
}

export function getPropertyCategory(id: PropertyCategoryId): PropertyCategory | undefined {
    return registry.get(id);
}

// Shared category for properties that aren't specific to one scene object type's own concerns.
export const CATEGORY_COMMON = registerCategory({
    id: definePropertyCategoryId('common'),
    name: 'properties.category.common.name',
    sortOrder: 0,
});

// Shape-sizing properties (rectangle width/height, circle radius, extrusion depth/thickness).
export const CATEGORY_DIMENSIONS = registerCategory({
    id: definePropertyCategoryId('dimensions'),
    name: 'properties.category.dimensions.name',
    sortOrder: 1,
});
